module.exports = __webpack_public_path__ + "img/my.c52af28.svg";